export const MAXIMUM_SHARE_COUPONS = 5
export const ENABLE_INVITE_FRIENDS_V2 = true
